export default {"src":"/_next/static/media/lost.0685d39c.gif","height":362,"width":480,"blurWidth":0,"blurHeight":0};